import React from 'react';

const Textarea = React.forwardRef(
  (
    { label, required = false, error = false, helperText, rows = 3, className = '', wrapperClassName = '', ...rest },
    ref
  ) => {
    const hasError = !!error;
    const effectiveHelperText = helperText || (typeof error === 'string' && error ? error : null);

    return (
      <div className={`w-full ${wrapperClassName}`}>
        {label && (
          <label className="mb-1 block text-[13px] font-medium text-[#212B36]">
            {label}
            {required && <span className="ml-0.5 text-[#EF4444]">*</span>}
          </label>
        )}
        <textarea
          ref={ref}
          rows={rows}
          className={`w-full resize-y rounded-lg border border-[#d0d5dd] bg-white px-3 py-2 text-sm text-[#212B36] placeholder:text-[#9aa3ab] focus:border-[#0061B2] focus:outline-none focus:ring-2 focus:ring-[#0061B2]/15 disabled:cursor-not-allowed disabled:bg-[#FAFBFE] ${
            hasError ? 'border-[#EF4444] focus:border-[#EF4444] focus:ring-[#EF4444]/15' : ''
          } ${className}`}
          {...rest}
        />
        {effectiveHelperText && (
          <p className={`mt-1 text-xs ${hasError ? 'text-[#EF4444]' : 'text-[#637381]'}`}>
            {effectiveHelperText}
          </p>
        )}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
export default Textarea;
